import clsx from 'clsx'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {ROUTES} from '../../../../constants'
import {KTSVG} from '../../../../helpers'
import {useLayout, usePageData} from '../../../core'

const DefaultTitle = () => {
  const {pageTitle, pageActions, pageTrailingActions, pageDescription, pageBreadcrumbs} =
    usePageData()
  const {config} = useLayout()
  const navigate = useNavigate()
  const {pathname} = useLocation()
  const isReportsPage = pathname.startsWith(ROUTES.REPORTS.BASE)
  const isSettingsConnectionsPage = pathname.startsWith(ROUTES.SETTINGS.CONNECTIONS.BASE)
  const showBackArrow = !isSettingsConnectionsPage
  return (
    <div
      id='gori-page-title'
      data-gori-swapper='true'
      data-gori-swapper-mode='prepend'
      data-gori-swapper-parent="{default: '#gori_content_container', xxl: '#gori_header_container'}"
      className={clsx(
        'header-default-title page-title d-flex align-items-start flex-wrap me-xxl-2 pb-xxl-0',
        {
          'pb-5': pageTitle,
          'header-default-title--reports': isReportsPage,
        }
      )}
    >
      {/* begin::Heading */}
      {pageTitle && (
        <>
          <div className='d-flex align-items-center gap-3 w-100 flex-wrap'>
            {showBackArrow && (
              <button
                type='button'
                className='header-default-title__back-arrow'
                aria-label='Go back'
                onClick={() => navigate(-1)}
              >
                <KTSVG path='/media/gori/left_arrow.svg' />
              </button>
            )}
            {pageActions && (
              <div className='d-flex align-items-center flex-shrink-0'>{pageActions}</div>
            )}
            {pageTrailingActions ? (
              <div className='d-flex align-items-center justify-content-between flex-grow-1 min-w-0 gap-2 flex-wrap'>
                <h1 className='d-flex flex-column text-dark fw-boldest my-0 fs-1 text-truncate min-w-0'>
                  {pageTitle}
                </h1>
                <div className='d-flex align-items-center flex-shrink-0'>{pageTrailingActions}</div>
              </div>
            ) : (
              <h1 className='d-flex flex-column text-dark fw-boldest my-0 fs-1'>{pageTitle}</h1>
            )}
          </div>
          <div className='mt-1'>{pageDescription}</div>
        </>
      )}

      {/* end::Heading */}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.pageTitle &&
        config.pageTitle.breadCrumbs && (
          <ul className='breadcrumb breadcrumb-dot fw-bold fs-base my-1'>
            {Array.from(pageBreadcrumbs)
              .filter((b) => !b.isSeparator)
              .map((item, index) => (
                <li
                  className={clsx('breadcrumb-item', {
                    'text-dark': !item.isSeparator && item.isActive,
                    'text-muted': !item.isSeparator && !item.isActive,
                  })}
                  key={`${item.path}${index}`}
                >
                  <Link className='text-muted' to={item.path}>
                    {item.title}
                  </Link>
                </li>
              ))}
            <li className='breadcrumb-item text-dark'>{pageTitle}</li>
          </ul>
        )}
    </div>
  )
}

export {DefaultTitle}
